import React from 'react';
import './Table.css';

function calculateTable(csvData) {
  let teams = {};
  csvData.forEach((game) => {
    
    if (game['Team 1'] === '?' || game['Team 2'] === '?') {
      return;
    }

    if (teams[game['Team 1']] === undefined) {
      teams[game['Team 1']] = {name: game['Team 1'], logo: game['Team 1 Logo'], points: 0, goals_s: 0, goals_c: 0} 
    }

    if (teams[game['Team 2']] === undefined) {
      teams[game['Team 2']] = {name: game['Team 2'], logo: game['Team 2 Logo'], points: 0, goals_s: 0, goals_c: 0} 
    }

    if (game['Score Team 1'] === '?' || game['Score Team 2'] === '?') {
      return;
    }
    if (game['Score Team 1'] === '' || game['Score Team 2'] === '') {
      return;
    }


    if (game['Score Team 1'] > game['Score Team 2']) {
      teams[game['Team 1']]['points'] += 3;
      // goals
      teams[game['Team 1']]['goals_s'] += Number(game['Score Team 1']);
      teams[game['Team 1']]['goals_c'] -= Number(game['Score Team 2']);

      teams[game['Team 2']]['goals_s'] += Number(game['Score Team 2']);
      teams[game['Team 2']]['goals_c'] -= Number(game['Score Team 1']);

    }

    if (game['Score Team 1'] < game['Score Team 2']) {
      teams[game['Team 2']]['points'] += 3;

      // goals
      teams[game['Team 2']]['goals_s'] += Number(game['Score Team 2']);
      teams[game['Team 2']]['goals_c'] -= Number(game['Score Team 1']);

      teams[game['Team 1']]['goals_s'] += Number(game['Score Team 1']);
      teams[game['Team 1']]['goals_c'] -= Number(game['Score Team 2']);
    }

    if (game['Score Team 1'] == game['Score Team 2']) {
      teams[game['Team 1']]['points'] += 1;
      teams[game['Team 2']]['points'] += 1;
      // goals
      teams[game['Team 1']]['goals_s'] += Number(game['Score Team 1']);
      teams[game['Team 2']]['goals_s'] += Number(game['Score Team 2']);

      teams[game['Team 1']]['goals_c'] -= Number(game['Score Team 1']);
      teams[game['Team 2']]['goals_c'] -= Number(game['Score Team 2']);
    }
  })

  return Object.values(teams).sort((a, b) => b['points'] - a['points']);
}

const Table = ({ csvData }) => {
  const tableData = calculateTable(csvData);
  
  return (
    <div className="scores-container">
      <table className="score-table">
        <thead>
        <tr>
          <td className="team">Name</td>
          <td className="points" alt="Points">P</td>
          <td className="goals">D</td>
          <td className="goals" alt="Goals scored">+</td>
          <td className="goals" ald="Goals conceded">- </td>
        </tr>
        </thead>
        <tbody>
          {tableData.map((row, index) => (
            <tr key={index} >
              <td className="team">
                <img className="team-logo" src={"/futsal/teams/" + row['logo'] + ".png"} /><br/>
                {row['name']}
              </td>
              <td className="points">{row['points']}</td>
              <td className="goals">{row['goals_s'] + row['goals_c']}</td>
              <td className="goals">{row['goals_s']}</td>
              <td className="goals">{row['goals_c']}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;